import React from "react";
import { faUser, faPhone, faMessage } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Header } from "semantic-ui-react";
import InspectionPhoneLink from "./InspectionPhoneLink";

export interface InspectionPanelOnSiteContactInfoProps {
  name: string | null | undefined;
  phone: string | null | undefined;
  instructions: string | null | undefined;
}
export default function InspectionPanelOnSiteContactInfo({
  name,
  phone,
  instructions,
}: InspectionPanelOnSiteContactInfoProps) {
  if (!name && !phone && !instructions) {
    return <></>;
  }
  return (
    <>
      <Header sub content='Onsite Contact' />
      {name && (
        <div className='tw-flex tw-items-center'>
          <FontAwesomeIcon className='tw-mr-2' icon={faUser} />
          {name}
        </div>
      )}
      {phone && (
        <div className='tw-flex tw-items-center'>
          <FontAwesomeIcon className='tw-mr-2' icon={faPhone} />
          <InspectionPhoneLink phone={phone} />
        </div>
      )}
      {instructions && (
        <div className='tw-flex tw-items-start'>
          <div>
            <FontAwesomeIcon className='tw-mr-2' icon={faMessage} />
          </div>
          <div>{instructions}</div>
        </div>
      )}
    </>
  );
}
